import { BuySellAssetControllerStages } from '@shared/types/frontend/assetPage';
import { ChevronLeft } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';
import { useSwap } from '@/contexts/SwapProvider';
const SlippageConfigStage = ({
  setStage
}) => {
  const _values = ['0.3', '0.5', '1'];
  const {
    setFromConfig,
    fromConfig,
    triggerQuote
  } = useSwap();
  const [selectedValue, setSelectedValue] = useState(fromConfig.slippage?.toString());
  const _handleToggle = (_: string) => {
    setSelectedValue(_);
  };
  const handleSetInput = (e, onBlur = false) => {
    const _value = e.target.value;

    // Allow only numbers and a dot with restrictions
    if (/^(0|[1-9][0-9]*)(\.[0-9]*)?$/.test(_value) || _value === '') {
      setSelectedValue(_value === '' ? onBlur ? '1' : '' : _value);
    }
  };
  const _onConfirmConfig = () => {
    setFromConfig({
      ...fromConfig,
      slippage: parseFloat(selectedValue)
    });
    triggerQuote();
    setStage(BuySellAssetControllerStages.default);
    return;
  };
  return <div className='h-[580px] flex flex-col gap-8 justify-between px-4 pb-2' data-sentry-component="SlippageConfigStage" data-sentry-source-file="SlippageConfigStage.tsx">
      <Button type='button' variant='blue' className='order-first rounded-full flex gap-2 items-center w-[74px] h-[31px] px-3 text-genius-cream' onClick={() => setStage(BuySellAssetControllerStages.default)} data-sentry-element="Button" data-sentry-source-file="SlippageConfigStage.tsx">
        <ChevronLeft className='w-[20px] h-[20px]' data-sentry-element="ChevronLeft" data-sentry-source-file="SlippageConfigStage.tsx" />
        <p>Back</p>
      </Button>
      <div className='flex flex-col gap-4 h-full'>
        <p>Slippage</p>

        <ToggleGroup type='single' value={selectedValue} onValueChange={_handleToggle} className='gap-4 border border-genius-blue rounded-full p-1 h-[56px]' data-sentry-element="ToggleGroup" data-sentry-source-file="SlippageConfigStage.tsx">
          {_values.map(value => <ToggleGroupItem key={value} value={value} disabled={value === selectedValue} className='disabled:opacity-100 opacity-50 text-genius-cream
            rounded-full h-[48px] w-[114px] text-[14px] data-[state=on]:bg-genius-blue'>
              {value}%
            </ToggleGroupItem>)}
        </ToggleGroup>
        <p className='opacity-50'>Custom:</p>
        <div className='flex items-center border border-genius-blue rounded-full px-2 h-[56px]'>
          <Input value={selectedValue} type='text' onBlur={e => handleSetInput(e, true)} onChange={handleSetInput} className='bg-transparent border-none focus:outline-none focus-visible:outline-none text-right' data-sentry-element="Input" data-sentry-source-file="SlippageConfigStage.tsx" />
          <p>%</p>
        </div>
      </div>
      <Button type='button' variant='blue' className='rounded-full w-full h-[56px]' onClick={() => _onConfirmConfig()} data-sentry-element="Button" data-sentry-source-file="SlippageConfigStage.tsx">
        Confirm
      </Button>
    </div>;
};
export default SlippageConfigStage;